module.exports = __webpack_public_path__ + "img/11fee34.jpg";